import ContainerCustom from "../../../Components/ContainerCustom";
import Table from "../../../Components/Table/Table";
import TableButton from "../../../Components/Buttons/TableButton";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import { useState } from "react";

export default function RulesList() {
  const [activeFilter, setActiveFilter] = useState([true, true, true]);

  return (
    <>
      <ContainerCustom
        header="لیست قوانین"
        headSVG="archive"
        colorfulFilterOptions={[
          {
            SVGName: "star",
            text: "عمومی",
            className: "w-28",
            color: "blue",
          },
          {
            SVGName: "star",
            text: "۲ فاز عادی",
            className: "w-28",
            color: "blue",
          },
        ]}
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
      >
        <Table
          showEmptyState
          columns={[
            { key: "uuid", label: "کد قانون" },
            {
              key: "category",
              label: "دسته قانون",
              render: (value) =>
                value === "general" ? (
                  <StatusColorful
                    SVGName="star"
                    text="عمومی"
                    className="w-28"
                    color="blue"
                  />
                ) : value === "twoPhase" ? (
                  <StatusColorful
                    SVGName="star"
                    text="۲ فاز عادی"
                    className="w-28"
                    color="blue"
                  />
                ) : (
                  ""
                ),
            },
            { key: "title", label: "عنوان قانون" },
            {
              key: "detail",
              label: "جزئیات",
              render: (value, row) => (
                <TableButton
                  text="مشاهده"
                  href=""
                  onClick={() => {window.location.href = `/rules/rule-info`}}
                  className="!py-1 !px-2 !rounded-md bg-zi-bg1-light dark:bg-zi-bg1-dark text-zi-text-light dark:text-zi-text-dark hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark"
                />
              ),
            },
          ]}
          data={[
            {
              uuid: "973017",
              category: "general",
              title: "شرایط برداشت سود حساب چیست؟",
              detail: "",
            },
            {
              uuid: "973017",
              category: "twoPhase",
              title: "اگر بازه زمانی فازهای تست تمام شود چه می‌شود؟",
              detail: "",
            },
          ]}
        />
      </ContainerCustom>
    </>
  );
}
